export const checkForOption = (
  selected: string[] | undefined,
  optionToCheck: string,
): boolean => {
  return !!selected && selected.includes(optionToCheck);
};
